const GLOBAL_URL = process.env.REACT_APP_API_URI || 'http://localhost:8080';
export default GLOBAL_URL;
